import React from 'react';
import logo from '../../assets/images/logo.png';

const Logo = ({ onClick }: { onClick?: () => void }) => (
  <a href={'#hero'} onClick={onClick} className="logo-link">
    <img className="logo-image" src={logo} alt="Yevhenii Logo" />
  </a>
);

export default Logo;
